import { atom } from "jotai";

export interface Mynews {
  isShowIndicatorCard: boolean;
}

export const myNewsAtom = atom<Mynews>({
  isShowIndicatorCard: false,
});
